import type { FunnelType, StepType, ExperienceType } from '../../types'

interface FunnelBadgeProps {
  type: 'funnel' | 'step' | 'experience'
  value: FunnelType | StepType | ExperienceType | string
}

const FUNNEL_TYPE_STYLES: Record<string, { bg: string; text: string; label: string }> = {
  post_purchase: { bg: 'var(--fn-type-post-purchase-bg)', text: 'var(--fn-type-post-purchase)', label: 'Post Purchase' },
  pre_purchase: { bg: 'var(--fn-type-pre-purchase-bg)', text: 'var(--fn-type-pre-purchase)', label: 'Pre Purchase' },
  landing_page: { bg: 'var(--fn-type-landing-bg)', text: 'var(--fn-type-landing)', label: 'Landing Page' },
}

const STEP_TYPE_STYLES: Record<string, { bg: string; text: string; label: string }> = {
  upsell: { bg: 'var(--fn-step-upsell-bg)', text: 'var(--fn-step-upsell)', label: 'Upsell' },
  downsell: { bg: 'var(--fn-step-downsell-bg)', text: 'var(--fn-step-downsell)', label: 'Downsell' },
  fallback: { bg: 'var(--fn-step-fallback-bg)', text: 'var(--fn-step-fallback)', label: 'Fallback' },
  checkout: { bg: 'var(--fn-step-fallback-bg)', text: 'var(--fn-step-fallback)', label: 'Checkout' },
}

export function FunnelBadge({ type, value }: FunnelBadgeProps) {
  const styles = type === 'funnel'
    ? FUNNEL_TYPE_STYLES[value]
    : STEP_TYPE_STYLES[value]

  if (!styles) {
    return (
      <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-fn-muted text-fn-text-sub">
        {value}
      </span>
    )
  }

  return (
    <span
      className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium"
      style={{ backgroundColor: styles.bg, color: styles.text }}
    >
      {styles.label}
    </span>
  )
}
